import React from 'react';

export const ABTestsContext = React.createContext({});

export default ABTestsContext;
